import { type FC } from 'react'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductCarouselLargeCarousel } from './ProductCarouselLargeCarousel'
import { type ProductCarouselLargeGalleryModalProps } from './ProductCarouselLargeGalleryModalProps'

const ProductCarouselLargeGalleryModal: FC<
  ProductCarouselLargeGalleryModalProps
> = ({
  images,
  initialIndex,
  isOpen,
  onClose,
  playVideoOnScrolledIntoView,
  productName,
  videos,
}) => (
  <Dialog
    onClose={onClose}
    open={isOpen}
    slotProps={{
      dialog: {
        className: 'w-full max-w-2xl',
      },
    }}
  >
    <DialogTitle onClose={onClose}>{productName}</DialogTitle>
    <DialogContent className="flex items-center justify-center overflow-hidden bg-light-primary-low">
      <ProductCarouselLargeCarousel
        images={images}
        initialIndex={initialIndex}
        playVideoOnScrolledIntoView={playVideoOnScrolledIntoView}
        productName={productName}
        videos={videos}
      />
    </DialogContent>
  </Dialog>
)

export { ProductCarouselLargeGalleryModal }
